import React, { useEffect, useState } from 'react';
import { useListadoRecordado } from '../../../components/useListadoRecordado';
import axios from '../../../axiosConfig';

import Table from 'react-bootstrap/Table';
import { useParams, useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import './ShowVoluntariados.css'; // Asegúrate de tener este archivo CSS en tu proyecto
import { useLoading } from '../../../components/LoadingContext';   
import { toast, ToastContainer } from 'react-toastify';
import PaginationTable from '../../../components/PaginationTable';
import { Modal } from 'react-bootstrap';
import { FaLocationDot } from "react-icons/fa6";
import { FaPerson } from "react-icons/fa6";
import { FaSync,FaSearch } from 'react-icons/fa';  // Importamos íconos de react-icons
import { ResponsiveContainer,Line, LineChart,BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,AreaChart,Area,Radar,RadarChart, PieChart, Cell, Pie, ComposedChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis } from 'recharts';
import { FaExpand, FaCompress } from 'react-icons/fa'; // Íconos para expandir/contraer
import { motion } from 'framer-motion';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';





const ShowVoluntariados = () => {
    const [voluntariados, setVoluntariados] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [filteredVoluntariados, setFilteredVoluntariados] = useState([]);
    const [searchCedula, setSearchCedula] = useState('');
    const [areaOptions, setAreaOptions] = useState([]);
    const [selectedArea, setSelectedArea] = useState('');
    const [nivelOptions, setNivelOptions] = useState([]);
    const [selectedNivel, setSelectedNivel] = useState('');
    const [generoOptions, setGeneroOptions] = useState([]);
    const [selectedGenero, setSelectedGenero] = useState('');
    const [centroOptions, setCentroOptions] = useState([]);
    const [tipoVoluntariadoOptions, setTipoVoluntariadoOptions] = useState([]);
    const [evalVoluntariadoOptions, setEvalVoluntariadoOptions] = useState([]);
    const [error, setError] = useState(null);
    const { id } = useParams();
    const { setLoading } = useLoading();
    const userRole = localStorage.getItem('role'); // Puede ser 'admin', 'superuser', 'invitado', etc.
    const [loadingData, setLoadingData] = useState(false); // Estado para controlar la recarga
    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#FF4567'];
    const [totalPages, setTotalPages] = useState(1); // Default to 1 page initially
    const [statistics, setStatistics] = useState({});
    const [mostrarSoloTabla, setMostrarSoloTabla] = useState(true);
    const [showModalInfo, setShowModalInfo] = useState(false);
                      
            const toggleTablaExpandida = () => {
        if (mostrarSoloTabla == true){
            getAllVoluntariados();
        }
        setMostrarSoloTabla(prevState => !prevState);
        
    };
    
const isActiveFilterValue = (v) => {
  if (v === null || v === undefined) return false;
  return String(v).trim() !== "";
};

 const activeFilterClass = (v) => (isActiveFilterValue(v) ? "is-active-filter" : "");
    

    const itemsPerPage = 10;

    const navigate = useNavigate();

    const handleShowModal = (id) => {
        setSelectedId(id);  // Almacena el ID del participante que se va a eliminar
        setShowModal(true); // Muestra el modal
    };
    
    const handleCloseModal = () => {
        setShowModal(false); // Cierra el modal
    };   

    useEffect(() => {
        setLoading(true);
        Promise.all([getVoluntariados(currentPage), fetchFilterOptions()]).finally(() => {
            setLoading(false);
            
        });
    }, [id]);
    // Página y filtros se recuerdan: al volver de Editar el listado queda donde estaba.
    const { filters, setFilters, currentPage, setCurrentPage } = useListadoRecordado('voluntariados', {
        centro_id: '',
        area_voluntariado_id: '',
        nivel_instruccion_id: '',
        genero_id: '',
        cedula_identidad:'',
        tipo_voluntariado_id:'',
        eval_voluntariado_id:'',
        nombres:'',
        fecha_registro:'',
        confirmar:true,
        fecha_inicio:'',
        fecha_fin:'',
    });


    const handlePageChange = (page) => {
        setCurrentPage(page);
        if (mostrarSoloTabla) {
            getVoluntariados(page);
        } else {
            getAllVoluntariados(page);
        }
    };

    const printInfo = async (filters) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                alert('Token no encontrado.');
                return;
            }

            const response = await axios.get(`/voluntariados-print`, {
                headers: { Authorization: `Bearer ${token}` },
                params: filters,
            });

            const jsonData = response.data.datos;
            const estadisticasData = response.data.estadisticas;

            if (!jsonData || jsonData.length === 0) {
                alert('No hay datos para exportar.');
                return;
            }

            const worksheet1 = XLSX.utils.json_to_sheet(jsonData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet1, 'Datos');

            const estadisticasArray = [];
            Object.entries(estadisticasData).forEach(([key, value]) => {
                if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
                    Object.entries(value).forEach(([subKey, subValue]) => {
                        if (typeof subValue === 'object' && subValue !== null) {
                            estadisticasArray.push({
                                Estadistica: `${key} - ${subKey}`,
                                Cantidad: subValue.count || 0,
                                Porcentaje: subValue.percentage ? `${subValue.percentage.toFixed(2)}%` : '0%',
                            });
                        } else {
                            estadisticasArray.push({
                                Estadistica: `${key} - ${subKey}`,
                                Valor: subValue,
                            });
                        }
                    });
                } else {
                    estadisticasArray.push({ Estadistica: key, Valor: value });
                }
            });

            const worksheet2 = XLSX.utils.json_to_sheet(estadisticasArray);
            XLSX.utils.book_append_sheet(workbook, worksheet2, 'Estadisticas');

            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            saveAs(blob, 'voluntariados.xlsx');
        } catch (error) {
            console.error('Error al generar el archivo Excel', error);
            alert('Hubo un error al generar el archivo Excel');
        }
    };

    const handlePrint = async () => {
        setShowModalInfo(false);
        await printInfo(filters);
    };

    const getAllVoluntariados = async (page = 1) => {
        // Buscar pasa el evento del clic como `page`: cualquier cosa que no sea
        // un número es la página 1. Y la página mostrada se fija aquí, así
        // coincide siempre con los datos (buscar, recargar, borrar, paginar).
        const pagina = Number.isInteger(page) && page > 0 ? page : 1;
        setCurrentPage(pagina);
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/voluntariados-estadisticas`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { ...filters, page: pagina },
            });
            
            const estadisticas = response.data.estadisticas || {};
            estadisticas.rangoEdades = estadisticas.rangoEdades || [];
            
            setVoluntariados(Array.isArray(response.data.datos.data) ? response.data.datos.data : []);
            setStatistics(estadisticas);
            setTotalPages(response.data.datos.last_page || 1); // Actualiza el total de páginas
             setLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error('Error fetching data');
            setVoluntariados([]);
            setStatistics({ rangoEdades: [] });
        }
    };

     const getVoluntariados = async (page = 1) => {
         // Igual que getAllVoluntariados: página normalizada y fijada aquí.
         const pagina = Number.isInteger(page) && page > 0 ? page : 1;
         setCurrentPage(pagina);
         setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/voluntariados-no-estadisticas`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { ...filters, page: pagina },
            });
            
            const estadisticas = response.data.estadisticas || {};
            estadisticas.rangoEdades = estadisticas.rangoEdades || [];
            
            setVoluntariados(Array.isArray(response.data.datos.data) ? response.data.datos.data : []);
            setStatistics(estadisticas);
             setLoading(false);
            setTotalPages(response.data.datos.last_page || 1); // Actualiza el total de páginas
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error('Error fetching data');
            setVoluntariados([]);
            setStatistics({ rangoEdades: [] });
        }
    };

    const fetchFilterOptions = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/filter-voluntariados`, { headers: { Authorization: `Bearer ${token}` } });
            
            setAreaOptions(response.data.area_voluntariado);
            setNivelOptions(response.data.nivel);
            setGeneroOptions(response.data.genero);
            setCentroOptions(response.data.centro);
            setTipoVoluntariadoOptions(response.data.tipo_voluntariado);
            setEvalVoluntariadoOptions(response.data.eval_voluntariado);


        } catch (error) {
            setError('Error fetching filter options');
            console.error('Error fetching filter options:', error);
        }
    };

    const deleteVoluntariados = async () => {
        
            try {
                const token = localStorage.getItem('token');
                await axios.delete(`/voluntariados/${selectedId}`,{
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                toast.success('Voluntariado eliminado con Éxito');
                setTimeout(() => {
                    getVoluntariados();
                }, 500);
                handleCloseModal();
                
            } catch (error) {
                setError('Error deleting data');
                toast.error('Error al eliminar Voluntariado');
                console.error('Error deleting data:', error);
            }
        
    };

    

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };



   const loadData = async () => {
        setLoadingData(true); // Inicia el estado de carga
        try {

        if (mostrarSoloTabla == true){
            getVoluntariados();
            fetchFilterOptions();
        }
        else {getAllVoluntariados();
            fetchFilterOptions()};
            
            
        } catch (error) {
            console.error('Error recargando los datos:', error); // Maneja el error si ocurre
        } finally {
            setLoadingData(false); // Detener el estado de carga cuando la solicitud haya terminado
        }
    };

    const totalVoluntariados= statistics.totalVoluntariados;
    const porcentajeMasculino = statistics?.porcentajesGenero?.masculino || 0;
    const porcentajeFemenino = statistics?.porcentajesGenero?.femenino || 0;
    const porcentajeOtros = statistics?.porcentajesGenero?.otros || 0;

    // const areaData = statistics?.participantesPorArea
    // ? Object.entries(statistics.participantesPorArea).map(([name, obj]) => ({
    //     name,           // Nombre del área
    //     value: obj.count, // El valor que deseas graficar (en este caso, `count`)
    // }))
    // : [];


    const centroData = statistics?.centro
    ? Object.entries(statistics.centro).map(([name, obj]) => ({
        name,
        value: obj.count,
    }))
    : [];

   

      const areaData = statistics?.participantesPorArea
    ? Object.entries(statistics.participantesPorArea).map(([name, obj]) => ({
        name,
        value: obj.count,
    }))
    : [];

    const NivelData = statistics?.nivelesInstruccion
    ? Object.entries(statistics.nivelesInstruccion).map(([name, obj]) => ({
        name,
        value: obj.count,
    }))
    : [];

     const tipoVoluntariadoData = statistics?.tipoVoluntariado
    ? Object.entries(statistics.tipoVoluntariado).map(([name, obj]) => ({
        name,
        value: obj.count,
    }))
    : [];



   
    
    

    const columns = [ "Cédula", "Nombres", "Apellidos","Acciones"];

    const renderItem = (dato) => (
        <tr key={dato.cedula_identidad}>
            <td className='col-cedula' >{dato.cedula_identidad}</td>
            <td className='col-nombre'>{dato.nombres}</td>
            <td className='col-apellido'>{dato.apellidos}</td>
            <td >
            <div className="d-flex justify-content-around">

                    <Button
                        variant="btn btn-info" 
                        onClick={() => navigate(`/Voluntariados/${dato.id}`)}
                        className="me-2"
                        title='Ver más'
                    >
                        <i className="bi bi-eye"></i>
                    </Button>
                    {userRole && (userRole === 'admin' || userRole === 'coordinador' || userRole === 'creador-cursos') && (

                        <Button
                        variant="btn btn-warning"
                        onClick={() => navigate(`/voluntariados/${dato.id}/edit`)}
                        className="me-2"
                        title='Editar'
                        >
                        <i className="bi bi-pencil-fill"></i>
                        </Button>
                    )}
                    {userRole === 'admin' && (
                   
                    <Button
                    variant="btn btn-danger"
                    onClick={() => handleShowModal(dato.id)}
                    className="me-2"
                    title='Eliminar'
                    >
                    <i className="bi bi-trash3-fill"></i>
                    </Button>
                    )}
                </div>
            </td>
        </tr>
    );
    
    
    return (
        <div className="container-fluid mt-2" style={{ fontSize: '0.85rem' }}>
            <motion.div 
                            initial={{ opacity: 1, maxHeight: "500px" }} // Establece una altura máxima inicial
                            animate={{
                                opacity: mostrarSoloTabla ? 0 : 1,
                                maxHeight: mostrarSoloTabla ? 0 : "500px", // Reduce la altura en transición
                            }}
                            transition={{ duration: 0.5, ease: "easeInOut" }} // Animación más fluida
                            style={{ overflow: "hidden" }} // Evita que los elementos internos se muestren fuera de la caja
                        >
            <div className="col-lg-11 mx-auto d-flex justify-content-center"> 
            <div className="stat-box mx-auto col-lg-11" style={{ maxWidth: '100%' }}> 
            {/* Total de Voluntariados */}
            <div className="stat-card" style={{  }}>
                <div className="stat-icon"><FaPerson  /></div>
                <div className="stat-number" style={{ color: '#58c765', fontSize: '1.2rem' }}>{totalVoluntariados}</div>
                <div className="stat-label">Total de Voluntariados</div>
            </div>
                {/* por genero */}
                <div className="stat-card" style={{  }}>
                <ResponsiveContainer width="100%" height={120}> {/* Ajustamos el width y height dinámicamente */}
                        <PieChart>
                        <Pie
                            data={[
                            { name: 'Masculino', value: porcentajeMasculino },
                            { name: 'Femenino', value: porcentajeFemenino },
                            ]}
                            dataKey="value"
                            startAngle={180} // Semicírculo
                            endAngle={0}
                            cx="50%"        // Centrar horizontalmente con porcentaje
                            cy="70%"        // Ajustamos la gráfica para pegarla más arriba
                            outerRadius="70%" // Radio basado en el porcentaje del contenedor para mayor flexibilidad
                            fill="#8884d8"
                            label={({ name, value }) => ` ${value.toFixed(2)}%`} // Mostrar los porcentajes
                            labelLine={true}
                        >
                            {/* Colores para cada sector */}
                            <Cell key="Masculino" fill="#185da7" />
                            <Cell key="Femenino" fill="rgba(254, 185, 56, 0.9)" />
                        </Pie>
                        <Legend 
                            layout="horizontal" 
                            verticalAlign="bottom" 
                            align="center" 
                            wrapperStyle={{ 
                            width: "88%", 
                            textAlign: "center", 
                            marginTop: "-15px", 
                            fontSize: '10px' 
                            }}
                        />
                        <Tooltip />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
                </div>
                </div> 
                </motion.div>

                <div className="row" style={{ marginTop: '10px' }}>
                <div className="col-lg-11 mx-auto"> {/* Agregamos 'mx-auto' para centrar */}
                    <div className="card-box" style={{ padding: '20px', width: '100%', margin: '0 auto' }}> 
                            <div className="d-flex justify-content-between align-items-center mb-3" style={{ gap: '0px' }}>
                        <h1>Lista de Voluntarios</h1>
                        <div className="d-flex align-items-center">
                        <Button 
                                variant="info me-2" 
                                onClick={toggleTablaExpandida} 
                                style={{ padding: '5px 15px' }}
                                title={mostrarSoloTabla ? "Mostrar Todo" : "Modo Tabla Expandida"}
                            >
                                {mostrarSoloTabla ? <FaCompress /> : <FaExpand />}
                            </Button>
                            <Form.Control
                                name="cedula_identidad"
                                type="text"
                                placeholder="Buscar por cédula"
                                value={filters.cedula_identidad}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.cedula_identidad)}
                            />
                            <Button
                                variant="info me-2"
                                onClick={loadData}
                                disabled={loadingData} // Deshabilita el botón si está cargando
                                style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                                title='Recargar datos'
                            >
                                {/* Icono de recarga */}
                                {loadingData ? (
                                <FaSync className="spin" /> // Ícono girando si está cargando
                                ) : (
                                <FaSync />
                                )}
                            </Button>
                                <Button
                                        variant="info me-2"
                                        onClick={() => {
                                            if (mostrarSoloTabla === false) {
                                                getAllVoluntariados();
                                            } else {
                                                getVoluntariados();
                                            }
                                        }}
                                        style={{ padding: '5px 10px', width: '120px' }}
                                        title="Buscar"
                                    >
                                        <FaSearch className="me-1" /> {/* Ícono de lupa */}
                                    </Button>
                                <Button
                                    variant="success"
                                    onClick={() => setShowModalInfo(true)}
                                    className="me-2"
                                    title="Exportar a Excel"
                                    style={{ padding: '5px 12px' }}
                                >
                                    <i className="bi bi-file-earmark-excel-fill"></i>
                                </Button>
                            {userRole === 'admin' || userRole === 'coordinador' || userRole === 'creador-cursos' || userRole === 'asist-centro' ? (

                            <Button variant="btn custom" onClick={() => navigate('create')} className="btn-custom" title='Crear Voluntariado'>
                            <i className="bi bi-person-plus-fill me-2  "></i> Nuevo
                            </Button>
                            ): null}
                        </div>
            </div>
            <div className="d-flex mb-3">

                 <Form.Control
                    name="nombres"
                    type="text"
                    placeholder="Buscar por nombre"
                    value={filters.nombres}
                    onChange={handleFilterChange}
                    className={activeFilterClass(filters.nombres)}
                />
                <Form.Select
                    name="area_voluntariado_id"
                    value={filters.area_voluntariado_id}
                    onChange={handleFilterChange}
                    className={activeFilterClass(filters.area_voluntariado_id)}
                    style={{ width: '150px' }}
                >
                    <option value="">Área</option>
                    {areaOptions.map(option => (
                        <option key={option.id} value={option.id}>{option.descripcion}</option>
                    ))}
                </Form.Select>

                <Form.Select
                    name="tipo_voluntariado_id"
                    value={filters.tipo_voluntariado_id}
                    onChange={handleFilterChange}
                    className={activeFilterClass(filters.tipo_voluntariado_id)}
                    style={{ width: '150px' }}
                >
                    <option value="">Tipo de Voluntariado</option>
                    {tipoVoluntariadoOptions.map(option => (
                        <option key={option.id} value={option.id}>{option.descripcion}</option>
                    ))}
                </Form.Select>
                <Form.Select
                    name="eval_voluntariado_id"
                    value={filters.eval_voluntariado_id}
                    onChange={handleFilterChange}
                    className={activeFilterClass(filters.eval_voluntariado_id)}
                    style={{ width: '150px' }}
                >
                    <option value="">Eval de Voluntariado</option>
                    {evalVoluntariadoOptions.map(option => (
                        <option key={option.id} value={option.id}>{option.descripcion}</option>
                    ))}
                </Form.Select>
                

                <Form.Select
                    name="nivel_instruccion_id"
                    value={filters.nivel_instruccion_id}
                    onChange={handleFilterChange}
                    className={activeFilterClass(filters.nivel_instruccion_id)}
                    style={{ width: '150px' }}
                >
                    <option value="">Nivel de Instrucción</option>
                    {nivelOptions.map(option => (
                        <option key={option.id} value={option.id}>{option.descripcion}</option>
                    ))}
                </Form.Select>

                <Form.Select
                    name="genero_id"
                    value={filters.genero_id}
                    onChange={handleFilterChange}
                    className={activeFilterClass(filters.genero_id)}
                    style={{ width: '150px' }}
                >
                    <option value="">Género</option>
                    {generoOptions.map(option => (
                        <option key={option.id} value={option.id}>{option.descripcion}</option>
                    ))}
                </Form.Select>
                <Form.Select
                    name="centro_id"
                    value={filters.centro_id}
                    onChange={handleFilterChange}
                    className={activeFilterClass(filters.centro_id)}
                    style={{ width: '150px' }}
                >
                    <option value="">Centro</option>
                    {centroOptions.map(option => (
                        <option key={option.id} value={option.id}>{option.descripcion}</option>
                    ))}
                </Form.Select>
            </div>
            <div className="d-flex align-items-center mb-3">
                    <Form.Label className="me-2 mb-0">Igual/mayor Fecha inicio : </Form.Label>
                    <Form.Control
                    type="date"
                    name="fecha_inicio"
                    value={filters.fecha_inicio}
                    onChange={handleFilterChange}
                    style={{ width: 'auto' }}
                    className={activeFilterClass(filters.fecha_inicio)}
                    />

                    <Form.Label className="me-2 mb-0">Menor/mayor Fecha Final : </Form.Label>
                    <Form.Control
                    type="date"
                    name="fecha_fin"
                    value={filters.fecha_fin}
                    onChange={handleFilterChange}
                    style={{ width: 'auto' }}
                    className={activeFilterClass(filters.fecha_fin)}
                    />
                   
                   
                </div> 
            <div className="cards-container"></div>
            <PaginationTable
                data={voluntariados}  // Datos filtrados
                itemsPerPage={itemsPerPage}
                columns={columns}
                renderItem={renderItem}
                currentPage={currentPage}  // Página actual
                onPageChange={handlePageChange}  // Función para cambiar de página
                totalPages={totalPages}  // <--- Añade esta línea si aún no está

                />



            {/* Modal de confirmación de exportación */}
            <Modal show={showModalInfo} onHide={() => setShowModalInfo(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="bi bi-file-earmark-excel-fill text-success me-2"></i>
                        Exportar a Excel
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center py-4">
                    <i className="bi bi-cloud-download" style={{ fontSize: '3.5rem', color: '#3D80C8' }}></i>
                    <p className="mt-3 mb-1 fw-semibold">¿Deseas descargar la información actual?</p>
                    <small className="text-muted">El archivo respetará los filtros aplicados.</small>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-end gap-2 w-100">
                        <Button variant="secondary" onClick={() => setShowModalInfo(false)}>
                            Cancelar
                        </Button>
                        <Button variant="success" onClick={handlePrint}>
                            <i className="bi bi-download me-1"></i> Descargar Excel
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

             {/* Modal  de eliminación */}
             <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar eliminación</Modal.Title>
                </Modal.Header>
                <Modal.Body>¿Estás seguro de que deseas eliminar este Voluntariado?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Cancelar
                    </Button>
                    <Button variant="danger" onClick={deleteVoluntariados}>
                        Eliminar
                    </Button>
                </Modal.Footer>
            </Modal>
            <ToastContainer />
        </div>
        <motion.div 
            initial={{ opacity: 1, height: "auto" }}
            animate={{ opacity: mostrarSoloTabla ? 0 : 1, height: mostrarSoloTabla ? 0 : "auto" }}
            transition={{ duration: 0.5 }}
        >
        <div className="col-lg-12 d-flex justify-content-between" style={{ gap: '20px', marginTop:'10px' }}>
            <div className="chart-box" style={{ flex: '1 1 31%', maxWidth: '31%', marginRight: '10px'}}>
            <h4 style={{ fontSize: '1.2rem', textAlign: 'center' }}>Distribución por Área</h4>

                <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                        <Pie
                            data={areaData}
                            dataKey="value"
                            nameKey="name"
                            cx="50%"
                            cy="50%"
                            outerRadius={100}
                            fill="#82ca9d"
                            label={({ name, value }) => `${name}: ${value}`}
                        >
                            {areaData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip />
                    </PieChart>
                </ResponsiveContainer>
          
            </div>

            <div className="chart-box " style={{flex: '1 1 31%', maxWidth: '31%', marginRight: '10px'}}>
                <h4 style={{ fontSize: '1.2rem' }}>Distribución por Nivel de Instrucción</h4>
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={NivelData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Bar dataKey="value" fill="#8884d8">
                        {NivelData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>


            </div>
            <div className="chart-box "style={{ flex: '1 1 31%', maxWidth: '31%', marginRight: '10px'}}>
            <h4 style={{ fontSize: '1.2rem' }}>Distribución por Centro</h4>
            <ResponsiveContainer width="100%" height={400}>
                <RadarChart data={centroData} cx="50%" cy="50%" outerRadius="80%">
                    <PolarGrid />
                    <PolarAngleAxis dataKey="name" />
                    <PolarRadiusAxis angle={30} domain={[0, Math.max(...centroData.map(d => d.count))]} />
                    <Radar name="Centros" dataKey="value" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} />
                    <Legend />
                    <Tooltip />
                </RadarChart>
            </ResponsiveContainer>

            </div>
            </div>
             <div className="chart-box " style={{flex: '1 1 99%', maxWidth: '99%', marginRight: '10px'}}>
             <h4 style={{ fontSize: '1.2rem' }}>Distribución por Tipo de Voluntariado</h4>
            <ResponsiveContainer width="100%" height={600}>
                <BarChart data={tipoVoluntariadoData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Bar dataKey="value" fill="#8884d8">
                        {tipoVoluntariadoData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>


        </div>
            </motion.div>
        </div>
       
        
        </div>
        </div>
    );
};

export default ShowVoluntariados;
